import { z } from "zod";
import { LimitInfoSchema } from "./LimitInfo";
import { QcConversationMemberSchema } from "./QcConversationMember";
import { GroupMemberSchema } from "./GroupMember";

export type GroupMembers = z.infer<typeof GroupMembersSchema>;
export const GroupMembersSchema = z.object({
  conversation_id: z.string(),
  memberLimitInfo: LimitInfoSchema,
  // members: z.array(QcConversationMemberSchema),
  members: z.array(GroupMemberSchema),
  nextPage: z.number(),
});
